export function isProd(): boolean {
  return process.env.REACT_APP_ENVIRONMENT === 'prod';
}

export function isHc(): boolean {
  return window.location.host.includes('pockethc.com');
}
